import { loginPath } from '@/libs/auth/login'

import { apiClient } from '../api-client'

import {
  LOCAL_STORAGE_ACCESS_TOKEN_KEY,
  LOCAL_STORAGE_REFRESH_TOKEN_KEY
} from './constants'

export const logout = async (): Promise<void> => {
  await apiClient.auth.logout.$put()
  localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)
  localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY)
  location.href = loginPath
}
